<template lang="pug">
v-app-bar.app-bar(app clipped-left elevation=0 outlined height="60x")
  template(v-if="isMobile")
    NavBarMobile.mr-0(:dark-mode="darkModeComputed" :enable-dark-mode="enableDarkMode" @toggleDrawer="toggleDrawer" @logout="logout" @toggleDarkMode="toggleDarkMode($event)")
  template(v-else)
    v-skeleton-loader.img-container(v-if="!logoLoaded" type="image" height="50px" light width="250px")
    //- div.img-container(v-else @click="goToHome")
      img.img-logo(:src="getImage")
    v-img.img-logo(v-else :src="getImage" max-width="300px" contain max-height="55px" @click="goToHome")
    template(v-if="navbarTitle && navbarTitle !== ''")
      v-spacer
      span.environment {{ navbarTitle }}
    v-spacer
    v-menu(v-if="enableDarkMode" offset-y :close-on-content-click="false")
      template(#activator="{ on: menu, attrs }")
        v-tooltip(v-if="!isMobile" v-model="configTooltip" bottom)
          template(#activator="{ on: tooltip }")
            v-btn(icon :class="{active: configTooltip}" v-bind="attrs" v-on="{...menu, ...tooltip}")
              v-icon mdi-cog-outline
          span Configurações
      v-list
        v-list-item
          v-list-item-content
            v-row(align="center" justify="center" no-gutters)
              v-col.pr-1(cols="auto")
                v-icon.pr-2 mdi-white-balance-sunny
              v-col(cols="auto")
                v-switch(v-model="darkModeComputed")
              v-col.pl-1(cols="auto")
                v-icon.pl-2 mdi-weather-night
    v-divider.mx-1(vertical inset)
    v-menu(v-model="menuValue" left offset-y)
      template(#activator="{on, attrs}" )
        v-btn.px-2(v-bind="attrs" depressed :class="{active: menuValue}" height="100%" v-on="on")
          v-row(no-gutters)
            v-col
              v-row(no-gutters align="end" justify="center")
                span.username {{getFirst(user.name) }}
              v-row(no-gutters align="end" justify="end")
                span.group Perfil {{ user.group }}
            v-col.pl-1(align-self="center")
              v-icon mdi-chevron-down
      v-list
        v-list-item(link :to="{name: 'profile'}")
          v-list-item-icon
            v-icon mdi-account
          v-list-item-title Visualizar Perfil
        v-list-item(link @click="goToAccountManagement")
          v-list-item-icon
            v-icon mdi-account-key
          v-list-item-title Gerenciar Conta
        v-list-item(link @click="logout")
          v-list-item-icon
            v-icon mdi-logout
          v-list-item-title Sair
    v-divider.mx-1(vertical inset)
    v-tooltip(bottom)
      template(#activator="{ on }")
        v-btn(icon v-on="on" @click="fullscreen")
          v-icon mdi-fullscreen
      span Tela cheia
    v-divider(vertical inset)
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapGetters } from "vuex";
import { VUE_APP_NAVBAR_TITLE } from "@/env.js";
export default {
  name: "NavBar",
  components: {
    NavBarMobile: () => import("@/components/navbar/NavBarMobile.vue"),
  },
  props: {
    user: {
      type: Object,
      default: () => {},
      isFullscreen: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    darkMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menuValue: null,
      configTooltip: null,
      navbarTitle: "",
    };
  },
  computed: {
    ...mapGetters("assets", ["getImgLogo"]),
    ...mapFields("assets", [
      "logoLoaded",
      "savedImgLogoNavbar",
      "savedImgLogoDarkNavbar",
    ]),
    ...mapFields("common", ["enableDarkMode"]),
    darkModeComputed: {
      get() {
        return this.darkMode;
      },
      set(value) {
        this.toggleDarkMode(value);
      },
    },
    getImage() {
      if (this.savedImgLogoDarkNavbar) {
        return this.darkModeComputed
          ? this.savedImgLogoDarkNavbar
          : this.savedImgLogoNavbar;
      }
      return this.savedImgLogoNavbar;
    },
  },
  beforeMount() {
    this.navbarTitle =
      process.env.NODE_ENV === "production"
        ? VUE_APP_NAVBAR_TITLE
        : process.env.VUE_APP_NAVBAR_TITLE;
  },
  methods: {
    getFirst(string) {
      const firstWord = string.split(" ")[0];
      return firstWord;
    },
    goToHome() {
      if (this.$route.name !== "home") {
        this.$router.push({ name: "home" });
      }
    },
    toggleDrawer() {
      this.$emit("toggleDrawer");
    },
    fullscreen() {
      if (!this.isFullscreen) {
        const elem = document.documentElement;
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) {
          /* Firefox */
          elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) {
          /* Chrome, Safari and Opera */
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
          /* IE/Edge */
          elem.msRequestFullscreen();
        }
        this.isFullscreen = true;
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          /* Firefox */
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          /* Chrome, Safari and Opera */
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          /* IE/Edge */
          document.msExitFullscreen();
        }
        this.isFullscreen = false;
      }
    },
    logout() {
      this.$emit("logout");
    },
    toggleDarkMode(value) {
      this.$emit("toggleDarkMode", value);
    },
    goToAccountManagement() {
      this.$emit("goToAccountManagement");
    },
  },
};
</script>

<style lang="sass" scoped>

.app-bar
  box-shadow: 0 5px 50px rgba(0,0,0,.25) !important
  background-color: var(--v-appBar-base) !important

.img-container
  max-width: 500px
  height: 60px
  padding-left: 100px

.img-logo
  // max-height: 100%
  // max-width: 100%
  cursor: pointer
  // object-fit: contain

.username, .group, .list
  color: var(--v-appBarText-base) !important

.username, .group
  font-size: 16px
  text-transform: capitalize
  font-family: 'Poppins'

.environment
  color: #f00
  font-weight: bold
  font-size: 20px
</style>
